export default {
  init() {
    // add class in header when dropdown open
    var mode = 0;
    $('.navbar-toggler').click(function () {
      if (mode == 0) {
        $('header.banner').addClass('h-100');
        mode = 1;
      } else {
        $('header.banner').removeClass('h-100');
        mode = 0;
      }
    });
    // JavaScript font-decrease /  font-increase
    $('.button-decrease').on('click', function () {
      $('.content-size').toggleClass('font-decrease');
      $('.content-size').removeClass('font-increase');
    });
    $('.button-increase').on('click', function () {
      $('.content-size').toggleClass('font-increase');
      $('.content-size').removeClass('font-decrease');
    });
    // JavaScript to be fired on all pages
    var navbar_height = $('.banner').height();
    $('body').css('padding-top', navbar_height);

    var check_rtl = false;

    if ($('html').attr('lang') == 'ar' || $('html').attr('dir') == 'rtl') {
      check_rtl = true;
    } else {
      check_rtl = false;
    }

    $('.main-slider').slick({
      infinite: true,
      arrows: false,
      dots: true,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      rtl: check_rtl,
      pauseOnHover: false,
      fade: true,
      cssEase: 'linear',
    });

    $('.main-slider .slick-dots').append('<span class="slider-action text-gray pause"><i class="icon-pause"></i></span>');

    $(document).on('click', '.slider-action', function () {
      if ($(this).hasClass('pause')) {
        $('.main-slider').slick('slickSetOption', {
          'autoplay': false,
        }, false);
        $('.main-slider').slick('refresh');
        $('.main-slider .slick-dots').append('<span class="slider-action text-black-rose play"><i class="icon-play"></i></span>');
      } else {
        if ($(this).hasClass('play')) {
          $('.main-slider').slick('slickSetOption', {
            'autoplay': true,
          }, false);
          $('.main-slider').slick('refresh');
          $('.main-slider .slick-dots').append('<span class="slider-action text-gray pause"><i class="icon-pause"></i></span>');
        }
      }
    });
    // news-slider
    $('.news-slider').slick({
      infinite: true,
      arrows: false,
      dots: true,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      rtl: check_rtl,
      fade: true,
      cssEase: 'linear',
    });
    // publication-slider
    $('.publication-slider').slick({
      infinite: true,
      arrows: false,
      dots: true,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      rtl: check_rtl,
      fade: true,
      cssEase: 'linear',
    });
    // video slider
    $('.video-slider').slick({
      infinite: true,
      arrows: true,
      dots: true,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      rtl: check_rtl,
      fade: true,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 800,
          settings: {
            arrows: false,
          },
        },
      ],
    });

    // video
    $(document).on('click', '.videoPoster', function (ev) {
      $(this).addClass('d-none');
      ev.preventDefault();
      var $poster = $(this);
      var $wrapper = $poster.closest('.videoWrapper');
      videoPlay($wrapper);
    });
    function videoPlay($wrapper) {
      var $iframe = $wrapper.find('.videoIframe');
      var src = $iframe.data('src');
      // hide poster
      $wrapper.addClass('videoWrapperActive');
      // add iframe src in, starting the video
      $iframe.attr('src', src);
    }

    $('a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
      var $current_tab = $(e.target);
      var tab = $current_tab.attr('data-tab');
      var collapse = $current_tab.attr('data-collapse');
      var $location = location.origin + location.pathname;
      var new_url = $location + '?tab=' + tab + '&c=' + collapse;
      history.pushState(null, null, new_url); // = "?type=" + type + "&tab=";
    });

    $('a[data-toggle="collapse"]').on('shown.bs.collapse', function (e) {
      var $current_tab = $(e.target);
      var tab = $current_tab.attr('data-tab');
      var $location = location.origin + location.pathname;
      var new_url = $location + '?tab=' + tab;
      history.pushState(null, null, new_url); // = "?type=" + type + "&tab=";
    });


    $('#gallery-images').lightGallery({
      thumbnail: true,
      showThumbByDefault: true,
      selector: 'a',
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js